/*!
 * devextreme-react
 * Version: 18.2.7
 * Build date: Sat Mar 09 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var helpers_1 = require("./helpers");
var template_wrapper_1 = require("./template-wrapper");
function createDxTemplate(createContentProvider, templateUpdater, keyFn) {
    var renderedModels = new Map();
    return {
        render: function (data) {
            var prevTemplateId = renderedModels.get(data.model);
            var templateId;
            if (prevTemplateId) {
                templateId = prevTemplateId;
            }
            else {
                templateId = keyFn ? keyFn(data.model) : "__template_" + helpers_1.generateID();
                if (data.model !== undefined) {
                    renderedModels.set(data.model, templateId);
                }
            }
            var container = unwrapElement(data.container);
            templateUpdater.setTemplate(templateId, function () {
                var model = data.model;
                if (model && model.hasOwnProperty("key")) {
                    model.dxkey = model.key;
                }
                var contentProvider = createContentProvider();
                return React.createElement(template_wrapper_1.TemplateWrapper, {
                    content: contentProvider(model),
                    container: container,
                    onRemoved: function () {
                        templateUpdater.removeTemplate(templateId);
                        renderedModels.delete(model);
                    },
                    onRendered: data.onRendered,
                    key: templateId
                });
            });
            return container;
        }
    };
}
exports.createDxTemplate = createDxTemplate;
function unwrapElement(element) {
    return element.get ? element.get(0) : element;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/devextreme-react/core/dx-template.js
// module id = 2421
// module chunks = 2